import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { DatabaseBuilderService } from './services/database-builder.service';
import { DataReaderService } from './services/data-reader.service';
import { DomainService } from './services/domain.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private jsonBuilder: DataReaderService,
    private domainService: DomainService,
  ) {
    this.initializeApp();
  }

  async initializeApp() {
    this.platform.ready().then(async () => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.jsonBuilder.initState();
      this.domainService.setDomains();

      this.askTrackingPermission();
    });
  }

  /**
   * Ask to track the users IDFA, Since the app itself doesnt need to handle
   * the response action isnt needed on either part
   * - Firebase will read the requested permission and handle itself accordingly
   * 
   * @returns null
   */
  askTrackingPermission() {
    if (this.platform.is('cordova') && this.platform.is('ios')) {
      if (window['cordova']) {
        window['cordova'].exec(null, null, 'idfa', 'requestPermission', []);
      }
    }
  }
}
